// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 1H15V9.5H21V14H3V9.5H9V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 16H21V23H16V20H14V23H3V16Z"}}]};

const ClearFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'clear-filled',
    ref,
    icon: element,
  },
));

ClearFilledIcon.displayName = 'ClearFilledIcon';

export default ClearFilledIcon;
